import * as angular from "angular";
import IProvideService = angular.auto.IProvideService;

/* @ngInject */
export const templateCacheBuster = ($provide: IProvideService) => {
    const cacheBuster = Date.now().toString();

    function templateFactoryDecorator($delegate) {
        const fromUrl = angular.bind($delegate, $delegate.fromUrl);
        $delegate.fromUrl = (url, params) => {
            if (url !== null && angular.isDefined(url) && angular.isString(url)) {
                url += (url.indexOf("?") === -1 ? "?" : "&");
                url += "v=" + cacheBuster;
            }

            return fromUrl(url, params);
        };

        return $delegate;
    }

    $provide.decorator("$templateFactory", ["$delegate", templateFactoryDecorator]);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/config/template-cache-buster.config.ts